import React from "react";
import PropTypes from "prop-types";

const DigiFormHidden = props => {
  return (
    <div className="form-group">
       <input
         id={`input${props.name}`}
         type="hidden"
         name={props.name}
         value={props.value}
       />
    </div>
  );
}

DigiFormHidden.propType = {
  value: PropTypes.string,
  name: PropTypes.string
};

export default DigiFormHidden;
